












































import Vue from 'vue';
import {Component, Provide} from "vue-property-decorator";
import CarItemC from './CarItemC.vue';

@Component({
    components: {
        CarItemC
    }
})
export default class ListeAnnoncesC extends Vue {


}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ListeAnnoncesC.vue